import {AfterViewInit, Component, OnInit} from '@angular/core';
import {EmpresasService} from "../../../superadmin/services/empresas.service";
import {ConstantsService} from "../../ConstantsService";
import {TemaPersonalizadoService} from "../../../services/tema-personalizado.service";
import { Router } from '@angular/router';
import { Tema, TEMAS_DO_SISTEMA } from '../../../shared/constants/theme-constants';

@Component({
  selector: 'app-tela-configuracao-temas',
  templateUrl: './tela-configuracao-temas.component.html',
  styleUrls: ['./tela-configuracao-temas.component.scss']
})
export class TelaConfiguracaoTemasComponent implements OnInit {
  empresa: any;
  ativando = false;
  temasPersonalizados: any[] = [];
  filtroAtual: 'todos' | 'personalizados' | 'comemorativos' = 'todos';

  // Lista completa de temas do sistema
  temasDoSistema: Tema[] = TEMAS_DO_SISTEMA;

  temasFiltrados: (Tema | any)[] = [];

  constructor(
    private empresasService: EmpresasService,
    private constantsService: ConstantsService,
    private temaService: TemaPersonalizadoService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.constantsService.empresa$.subscribe((empresa: any) => {
      if (!empresa) return;
      this.empresa = empresa;
    });
    this.carregarTemasPersonalizados();
  }

  carregarTemasPersonalizados() {
    this.temaService.listeTemas().then(temas => {
      this.temasPersonalizados = temas.map(tema => ({
        ...tema,
        tipo: 'personalizado'
      }));
      this.aplicarFiltro('todos');
    });
  }

  aplicarFiltro(filtro: 'todos' | 'personalizados' | 'comemorativos') {
    this.filtroAtual = filtro;

    let temasFiltrados: (Tema | any)[] = [];

    // Sempre inclui os temas personalizados se existirem
    if (filtro === 'todos' || filtro === 'personalizados') {
      temasFiltrados = [...this.temasPersonalizados];
    }

    // Filtra os temas do sistema de acordo com o filtro selecionado
    const temasDoSistemaFiltrados = this.temasDoSistema.filter(tema => {
      if (filtro === 'todos') return true;
      if (filtro === 'comemorativos') return tema.tipo === 'comemorativo';
      return false;
    });

    this.temasFiltrados = [...temasFiltrados, ...temasDoSistemaFiltrados];
  }

  ativarTemaPersonalizado(tema: any) {
    this.ativando = true;

    this.empresasService.ativarTema(this.empresa.id, tema.id).then(() => {
      return this.empresasService.logada();
    }).then((empresaAtualizada: any) => {
      this.ativando = false;
      this.constantsService.mudouEmpresa(empresaAtualizada);
    }).catch((erro) => {
      this.ativando = false;
      console.error('Erro ao ativar tema:', erro);
      alert('Erro ao ativar tema. Tente novamente.');
    });
  }

  ativarTema(temaCodigo: string) {
    this.ativando = true;

    this.empresasService.ativarTema(this.empresa.id, temaCodigo).then(() => {
      return this.empresasService.logada();
    }).then((empresaAtualizada: any) => {
      this.ativando = false;
      this.constantsService.mudouEmpresa(empresaAtualizada);
    }).catch((erro) => {
      this.ativando = false;
      console.error('Erro ao ativar tema:', erro);
      alert('Erro ao ativar tema. Tente novamente.');
    });
  }

  desativarTema() {
    this.ativando = true;

    this.empresasService.ativarTema(false, '').then(() => {
      return this.empresasService.logada();
    }).then((empresaAtualizada: any) => {
      this.ativando = false;
      this.constantsService.mudouEmpresa(empresaAtualizada);
    }).catch((erro) => {
      this.ativando = false;
      console.error('Erro ao desativar tema:', erro);
      alert('Erro ao desativar tema. Tente novamente.');
    });
  }

  editarTema(tema: any) {
    this.router.navigate(['/admin/temas/criar/', tema.id]);
  }

  criarTemaPersonalizado() {
    this.router.navigate(['/admin/temas/criar']);
  }

  isTemaAtivo(tema: any): boolean {
    if (tema.tipo === 'personalizado') {
      return this.empresa.temaPersonalizado?.id === tema.id;
    }
    if (tema.codigo === 'meucardapioclassico') {
      return !this.empresa.tema || this.empresa.tema === 'meucardapioclassico';
    }
    return this.empresa.tema === tema.codigo;
  }

  handleImageError(event: Event, imagem: string) {
    const img = event.target as HTMLImageElement;
    if (img.src.endsWith('.png')) {
      img.src = `/assets/loja/${imagem.replace('.png', '.jpg')}`;
    } else if (img.src.endsWith('.jpg')) {
      img.src = `/assets/loja/${imagem.replace('.png', '.jpeg')}`;
    }
  }
}
